"use client"

import { CopilotKit } from "@copilotkit/react-core"
import { ReactNode } from "react"
import { usePathname } from "next/navigation"
import { CopilotErrorBoundary } from "./copilot-error-boundary"
import { CopilotActiveProvider } from "./copilot-context"

interface CopilotProviderProps {
  children: ReactNode
}

export function CopilotProvider({ children }: CopilotProviderProps) {
  const pathname = usePathname()

  const isAuthPage =
    pathname === "/login" ||
    pathname === "/register" ||
    pathname === "/forgot-password" ||
    pathname === "/auth/reset-password"
  const isLandingPage = pathname === "/"

  const apiKey = process.env.NEXT_PUBLIC_COPILOTKIT_API_KEY
  const runtimeUrl = process.env.NEXT_PUBLIC_COPILOTKIT_RUNTIME_URL
  const disableCopilotKit = process.env.NEXT_PUBLIC_DISABLE_COPILOTKIT === "true"

  const shouldDisable =
    isAuthPage || isLandingPage || disableCopilotKit || (!apiKey && !runtimeUrl)

  if (shouldDisable) {
    return (
      <CopilotActiveProvider active={false}>
        {children}
      </CopilotActiveProvider>
    )
  }

  if (runtimeUrl) {
    return (
      <CopilotActiveProvider active={true}>
        <CopilotErrorBoundary fallback={<CopilotActiveProvider active={false}>{children}</CopilotActiveProvider>}>
          <CopilotKit runtimeUrl={runtimeUrl}>
            {children}
          </CopilotKit>
        </CopilotErrorBoundary>
      </CopilotActiveProvider>
    )
  }

  return (
    <CopilotActiveProvider active={true}>
      <CopilotErrorBoundary fallback={<CopilotActiveProvider active={false}>{children}</CopilotActiveProvider>}>
        <CopilotKit publicApiKey={apiKey!}>
          {children}
        </CopilotKit>
      </CopilotErrorBoundary>
    </CopilotActiveProvider>
  )
}
